import { useEffect } from "react";
import { api } from "./api.js";

interface RuntimeSettings {
  general?: { productName?: string };
  branding?: { primaryColor?: string; secondaryColor?: string; faviconUrl?: string };
}

export function RuntimeBrand() {
  useEffect(() => {
    void api<RuntimeSettings>("/api/runtime/settings")
      .then((settings) => {
        if (settings.general?.productName) document.title = settings.general.productName;
        if (settings.branding?.primaryColor)
          document.documentElement.style.setProperty("--accent", settings.branding.primaryColor);
        if (settings.branding?.secondaryColor)
          document.documentElement.style.setProperty(
            "--accent-strong",
            settings.branding.secondaryColor,
          );
        if (settings.branding?.faviconUrl) {
          const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
          const link = existing ?? document.head.appendChild(document.createElement("link"));
          link.rel = "icon";
          link.href = settings.branding.faviconUrl;
        }
      })
      .catch(() => {
        // Startup branding is optional; authenticated requests still surface their own errors.
      });
  }, []);
  return null;
}
